import { gql } from '@apollo/client';
import React from 'react';
import { BreadcrumbList, ListItem } from 'schema-dts';
import { Vertical, VERTICALS } from '@moda/portal-stanchions';
import { SchemaOrgProductBreadcrumbsFragment } from '../../generated/types';
import { hrefFor } from '../../routers';
import { getVerticalBreadcrumbUrl } from '../../lib/getVerticalBreadcrumbUrl';

export const SCHEMA_ORG_PRODUCT_BREADCRUMBS_FRAGMENT = gql`
  fragment SchemaOrgProductBreadcrumbsFragment on Variant {
    gender
    category
    subcategory
    designerSlug: designer_slug
  }
`;

const section = 'shop';

interface Props {
  variant: SchemaOrgProductBreadcrumbsFragment;
}

export const SchemaOrgProductBreadcrumbs: React.FC<Props> = ({ variant }) => {
  const { gender, category: categories, subcategory: subcategories, designerSlug } = variant;
  const vertical = VERTICALS[gender as Vertical];

  const category = categories[0];
  const subcategory = subcategories[0];

  const itemListElement: ListItem[] = [
    {
      '@type': 'ListItem',
      position: 1,
      name: vertical,
      item: getVerticalBreadcrumbUrl(vertical)
    }
  ];
  if (category) {
    itemListElement.push({
      '@type': 'ListItem',
      position: itemListElement.length,
      name: category,
      item: hrefFor.ProductCategoryListingPage({ vertical, section, category })
    });
  }
  if (category && subcategory) {
    itemListElement.push({
      '@type': 'ListItem',
      position: itemListElement.length,
      name: subcategory,
      item: hrefFor.ProductCategoryListingPage({ vertical, section, category, subcategory })
    });
  }
  if (designerSlug) {
    itemListElement.push({
      '@type': 'ListItem',
      position: itemListElement.length,
      name: designerSlug,
      item: hrefFor.DesignerPage({ vertical, section, designerSlug })
    });
  }

  const schema: BreadcrumbList = {
    '@type': 'BreadcrumbList',
    itemListElement
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
};
